import {Avatar, DataStatus, LayoutNotificationBackgroud} from 'platform/components';
import {Box, Clickable, HStack, Text, VStack} from 'platform/foundation';

import {useLazyGetDocument360RedirectUrlQuery} from '@dms/api/security';
import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';

import {pushGtmEvent, suffixTestId, TestIdProps} from 'shared/web';

import {OmneticReleaseNote} from '../../../releaseNotes';

export function Release(props: OmneticReleaseNote & TestIdProps) {
  const [getDocument360RedirectUrl, {isLoading}] = useLazyGetDocument360RedirectUrlQuery();

  const handleRedirectToDoc360 = () => {
    pushGtmEvent({
      event: 'button_click',
      event_id: 'top_bar_release_popup_item_click',
      value: props.url,
    });

    getDocument360RedirectUrl({redirectTo: props.url})
      .unwrap()
      .then((res) => res.redirectUrl)
      .then(window.open)
      .catch(handleApiError);
  };

  return (
    <DataStatus isLoading={isLoading}>
      <Clickable onClick={handleRedirectToDoc360}>
        <LayoutNotificationBackgroud>
          <Box minHeight={18} padding={2} overflow="hidden">
            <HStack spacing={2} justify="stretch">
              <Avatar icon={props.type === 'feature' ? 'action/stars' : 'action/bug_report'} />
              <VStack spacing={1} grow={1}>
                <HStack spacing={2}>
                  <Text
                    alternative
                    size="xSmall"
                    color="secondary"
                    inline
                    data-testid={suffixTestId('title', props)}
                  >
                    {props.title || i18n.t('general.labels.titleNotAvailable')}
                  </Text>
                </HStack>
                <Text size="xSmall" color="link" data-testid={suffixTestId('description', props)}>
                  {props.description || i18n.t('general.labels.descriptionNotAvailable')}
                </Text>
                <HStack justify="space-between">
                  <Text
                    size="xSmall"
                    color="secondary"
                    data-testid={suffixTestId('dateTime', props)}
                  >
                    {props.dateTime}
                  </Text>
                  {props.versionNumber && (
                    <Text
                      size="xSmall"
                      color="secondary"
                      data-testid={suffixTestId('versionNumber', props)}
                    >
                      {i18n.t('general.labels.appVersion')}: {props.versionNumber}
                    </Text>
                  )}
                </HStack>
              </VStack>
            </HStack>
          </Box>
        </LayoutNotificationBackgroud>
      </Clickable>
    </DataStatus>
  );
}
